<template>
  <div>
    <div class="banquet-info">{{ serviceContent }}</div>
    <div class="banquet-privacy">
      當你點選下方「同意」按鈕時，則表示您已閱讀並同意「
      <label @click="showPrivacy" class="banquet-privacy-label"
        >隱私權政策</label
      >
      」聲明。
    </div>
    <div class="banquet-privacy-agree">
      <div class="temple-button-text" @click="clickAgree">同意</div>
    </div>
  </div>
</template>

<script>
import store from 'Store/store';

export default {
  name: 'ServiceBanquetStep1',
  mounted() {},
  methods: {
    showPrivacy() {
      store.dispatch('main/showPopup', {
        title: '隱私權政策',
        content: store.state.main.onlineStatus.policyInfo.content,
      });
    },
    clickAgree() {
      this.$emit('nextStep');
    },
  },
  computed: {
    serviceContent() {
      return store.state.main.onlineStatus.reposeInfo.serviceInfo.content;
    },
  },
};
</script>

<style>
.banquet-info {
  border: 1px solid #979797;
  margin: 50px 5px 0px 5px;
  padding: 30px 20px 30px 20px;
  font-size: 16px;
  color: #000000;
  white-space: pre-line;
}
.banquet-privacy {
  margin: 50px 5px 0px 5px;
  font-size: 16px;
  color: #000000;
}
.banquet-privacy-label {
  font-size: 16px;
  font-weight: bold;
  text-decoration: underline;
  color: #000000;
  cursor: pointer;
}
.banquet-privacy-agree {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>
